import Parse from "parse";

const gateway = {
  compareFaces(documentImage, selfieImage, threshold) {
    return Parse.Cloud.run("comparefaces", {
      documentImage,
      selfieImage,
      threshold
    });
  }
};

export default gateway;
